import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { Clearance } from "@/services/mrfiktiv/v1/Clearance";
import {
  MrfiktivClearanceControllerGetParamsGen,
  MrfiktivClearanceViewModelGen,
  MrfiktivCreateClearanceDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateClearanceDtoGen,
  MrfiktivUpdateClearanceStatusDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";

class ClearanceService {
  private readonly client: Clearance;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.client = new Clearance(mrfiktivHttpClientProvider.client());
  }

  async create(partnerId: string, dto: MrfiktivCreateClearanceDtoGen): Promise<MrfiktivClearanceViewModelGen> {
    const response = await this.client.clearanceControllerCreate(partnerId, dto);
    return response.data;
  }

  async getOne(partnerId: string, clearanceId: string): Promise<MrfiktivClearanceViewModelGen> {
    const response = await this.client.clearanceControllerGetOne(partnerId, clearanceId);
    return response.data;
  }

  async getAll(params: MrfiktivClearanceControllerGetParamsGen): Promise<
    MrfiktivPageViewModelGen & {
      data?: MrfiktivClearanceViewModelGen[];
    }
  > {
    const repairEstimates = (await this.client.clearanceControllerGet(params)).data;

    return repairEstimates;
  }

  async update(
    partnerId: string,
    clearanceId: string,
    dto: MrfiktivUpdateClearanceDtoGen
  ): Promise<MrfiktivClearanceViewModelGen> {
    const response = await this.client.clearanceControllerUpdate(partnerId, clearanceId, dto);
    return response.data;
  }

  /**
   * Set clearance as cleared
   * @param partnerId
   * @param clearanceId
   * @returns
   */
  async setIsCleared(partnerId: string, clearanceId: string): Promise<MrfiktivClearanceViewModelGen> {
    const response = await this.client.clearanceControllerSetIsCleared(partnerId, clearanceId);
    return response.data;
  }

  async delete(partnerId: string, clearanceId: string): Promise<MrfiktivClearanceViewModelGen> {
    const response = await this.client.clearanceControllerDelete(partnerId, clearanceId);
    return response.data;
  }

  async updateStatus(
    partnerId: string,
    clearanceId: string,
    dto: MrfiktivUpdateClearanceStatusDtoGen
  ): Promise<MrfiktivClearanceViewModelGen> {
    const response = await this.client.clearanceControllerUpdateStatus(partnerId, clearanceId, dto);
    return response.data;
  }
}

export default new ClearanceService(new MrfiktivHttpClientProvider());
